import { render, staticRenderFns } from "./appoint.vue?vue&type=template&id=581bfc22&scoped=true&"
import script from "./appoint.vue?vue&type=script&lang=js&"
export * from "./appoint.vue?vue&type=script&lang=js&"
import style0 from "./appoint.vue?vue&type=style&index=0&id=581bfc22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581bfc22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581bfc22')) {
      api.createRecord('581bfc22', component.options)
    } else {
      api.reload('581bfc22', component.options)
    }
    module.hot.accept("./appoint.vue?vue&type=template&id=581bfc22&scoped=true&", function () {
      api.rerender('581bfc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/appoint.vue"
export default component.exports